import i18n from "@/helpers/i18n";

/**
 * Formatuje datę z API (ISO) w formacie bieżącego języka panelu
 * @param value Data w formacie ISO
 */
export function formatDate(value: string): string {
    const culture = i18n.global.locale.value === "pl" ? "pl-PL" : "en-GB";
    return new Date(value).toLocaleDateString(culture);
}
